import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const cashJourneyRoutes = [
  {
    id: 'cash-out',
    trackingName: 'Cash Out',
    path: 'cash-out',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashOut')).JourneyCashOut,
    }),
  },
  {
    id: 'add-cash',
    trackingName: 'Add Cash',
    path: 'add-cash',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddCash')).JourneyAddCash,
    }),
  },
  {
    id: 'add-cash-amount',
    trackingName: 'Add Cash Amount',
    path: 'add-cash/:cents_amount',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddCashAmount')).JourneyAddCashAmount,
    }),
  },
] as const satisfies JourneyRoute[]
